import { state as _state } from "./state";
import "./AsyncQueue";
import { parseMessage } from "./message";
let state;
_state.subscribe((__state) => (state = __state));
export default class Connection {
    constructor(url) {
        this.last64Messages = [];
        this.messageListeners = new Map();
        this.sendMessageQueue = [];
        this.socket = new WebSocket(url);
        this.socket.onopen = () => {
            this.handleParsedMessage({ type: "ConnectedToServer" });
            while (this.sendMessageQueue.length > 0) {
                const message = this.sendMessageQueue.shift();
                console.log("debug, send message:", message);
                this.socket.send(JSON.stringify(message));
            }
        };
        this.socket.onclose = () => {
            this.handleParsedMessage({ type: "LostConnection" });
        };
        // this.socket.onerror = () =>
        //     this.handleParsedMessage({ type: "CouldNotConnect" });
        this.socket.onmessage = (rawMessage) => {
            const objectMessage = JSON.parse(rawMessage.data);
            const parsedMessage = parseMessage(objectMessage);
            this.handleParsedMessage(parsedMessage);
        };
    }
    handleParsedMessage(parsedMessage) {
        console.debug("debug, received message:", parsedMessage);
        this.last64Messages.push(parsedMessage);
        if (this.last64Messages.length > 64)
            this.last64Messages.shift();
        for (const [page, messageListener] of this.messageListeners) {
            if (page === "all" || page === state.currentPage) {
                messageListener(parsedMessage);
            }
        }
    }
    unregisterMessageListener(page) {
        if (this.messageListeners.delete(page)) {
            console.debug("unregistred message listener", page);
        }
    }
    registerMessageListener(page, callback) {
        if (!this.messageListeners.has(page)) {
            this.messageListeners.set(page, callback);
            console.debug("registered message listener", page);
            this.last64Messages.forEach((val) => callback(val));
        }
    }
    sendMessage(message) {
        if (this.socket.readyState === this.socket.OPEN) {
            console.debug("debug, send message:", message);
            this.socket.send(JSON.stringify(message));
        }
        else {
            this.sendMessageQueue.push(message);
        }
    }
    applyMove(row, column) {
        this.sendMessage({ ApplyMove: { row, column } });
    }
    async createLobby() {
        this.sendMessage("CreateLobby");
    }
    async quickPlay() {
        this.sendMessage("QuickPlay");
    }
    async joinLobby(code) {
        this.sendMessage({ JoinLobby: code });
    }
}
window["Connection"] = Connection;
